<template lang="pug">
	.select-v3
		label(v-if="label.trim() != ''" :for="id") {{label}}
		.select-container(:class="{'error': error}")
			select(v-model="currentValue" :id="id" @change="emitChange($event)" :aria-labelledby="labelledBy")
				option(v-for="option of $props.options" :value="option") {{option.label}}
			span.arrow-down
		.error-message(v-if="errorMessage && errorMessage != ''")
			| {{errorMessage}}
</template>

<style lang="stylus" scoped>
@import '../assets/css/variables.styl'

.select-v3
	position: relative
	line-height: body-font-line-height-xs
	label
		font-size: body-font-size-sm
		line-height: body-font-line-height-xs + 0.2
		padding-bottom: 10px
		margin: 0
		box-sizing: border-box

	.select-container
		position: relative
		display: block
		width: 100%
		background-color: #fff
		border: 1px solid sfc-gray-dark
		border-radius()
		box-shadow-dd()
		&.error
			border: 1px solid chart-red
			select
				&:focus
					error-box-shadow()
	select
		position: relative
		display: block
		width: 100%
		max-width: 100%
		border: 0
		-webkit-appearance: none
		-moz-appearance: none
		appearance: none
		color: #000
		font-size: body-font-size
		line-height: body-font-line-height
		padding: 10px 25px 10px 15px
		background-color: transparent
		z-index: 41

		&:focus
			focus-box-shadow()

		@media(max-width: 575px)
			font-size: body-font-size-md

	.arrow-down
		width: 0
		height: 0
		display: block
		border-left: 5px solid transparent
		border-right: 5px solid transparent
		border-top: 6px solid #000
		position: absolute
		top: calc(50% - 2px)
		right: 15px
		transition: all 0.5s ease
		-webkit-transition: all 0.5s ease
		cursor: pointer
		z-index: 15

	.error-message
		font-size: body-font-size-xs
		color: urgent-red

</style>

<script>

export default {
	components: {
	},
	props: {
		value: {
			default: undefined
		},
		errorMessage: {
			type: String,
			default: ""
		},
		error: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ""
		},
		options: {
			type: Array,
			required: true
		},
		labelledBy:{
			type: String,
			default: undefined
		}
	},
	mounted(){
		let randomNumber = Math.ceil(Math.random()*1000000)
		this.id = `sfc-select-v3-${randomNumber}`
	},
	data () {
		return {
			currentValue: this.$props.value,
			id: undefined
		}
	},
	watch: {
		// whenever value changes, this function will run
		value (newValue, oldValue) {
			this.currentValue = newValue
		}
	},
	methods: {
		emitChange (event) {
			this.$emit("input", this.currentValue),
			this.$emit("change")
		}
	}
}
</script>
